import { create } from 'zustand';
import { cloneDeep } from 'lodash';
import { v4 } from 'uuid';

// eslint-disable-next-line import/prefer-default-export
export const useEditEmailTypesStore = create(setState => ({
  editMode: false,
  emailTypes: [],
  setEmailTypes: emailTypes => setState({ emailTypes: cloneDeep(emailTypes) }),
  toggleEditMode: editMode =>
    setState(prevState => ({
      editMode: typeof editMode === 'boolean' ? editMode : !prevState.editMode,
    })),
  addNewEmailType: () => {
    setState(prevState => ({
      emailTypes: [
        ...prevState.emailTypes,
        { id: v4(), name: 'New Email Type', publicName: '', new: true },
      ],
    }));
  },
  removeEmailType: id => {
    setState(prevState => {
      return {
        emailTypes: prevState.emailTypes.filter(e => e.id !== id),
      };
    });
  },
  editEmailType: (id, payload) => {
    setState(prevState => {
      const nextState = [...prevState.emailTypes],
        typeIndex = nextState.findIndex(e => e.id === id);
      nextState[typeIndex] = {
        ...nextState[typeIndex],
        ...payload,
      };
      return {
        emailTypes: nextState,
      };
    });
  },
}));
